import { bindEvent } from 'vtils'
import { showDialog } from '@/utils/show_dialog'
import { useActivated } from './use_activated'
import { useContext } from './use_context'
import type { NavigationGuard } from 'vue-router'

export function useLeavePageConfirm(canLeave: () => boolean, message: string) {
  // 多彩宝事件
  useActivated(() => {
    ;(window as any).__dcb_before_close__ = (next: any) => {
      if (canLeave()) {
        next()
      } else {
        showDialog({
          message: message,
          confirmText: '确认',
          cancelText: '取消',
          style2: true,
          onConfirm: () => next(),
        })
      }
    }
    return () => {
      ;(window as any).__dcb_before_close__ = undefined
    }
  })

  // Vue 路由事件
  const ctx: any = useContext()
  const hooks: any = ctx.constructor.options.beforeRouteLeave || []
  hooks.push(((to, from, next) => {
    if (canLeave()) {
      next()
    } else {
      showDialog({
        message: message,
        confirmText: '确认',
        cancelText: '取消',
        style2: true,
        onConfirm: () => next(),
        onCancel: () => next(false),
      })
    }
  }) as NavigationGuard)
  ctx.constructor.options.beforeRouteLeave = hooks

  // 窗口事件
  useActivated(() =>
    bindEvent(window)('beforeunload', e => {
      if (!canLeave()) {
        // 在旧版本浏览器中，事件的返回值会被展示在对话框中。但从Firefox 44，Chrome 51，Opera 38，和Safari 9.1以后，返回文本将不会被展示，换言之，无法自定义弹窗提示文本。
        if (e) {
          e.returnValue = message
        }
        return message
      }
    }),
  )
}
